export default {
  birthDateInvalid:
    "Fecha no válida. Debe tener entre 18 y 110 años (año {{minYear}} a {{maxYear}})",
  documentDateInvalid:
    "Fecha no válida. El año debe estar entre 2000 y {{maxYear}}",
  maxChars: "Debe tener como máximo {{max}} caracteres",
  fieldRequired: "{{field}} es obligatorio",
  fieldMinChars: "{{field}} debe tener al menos {{min}} caracteres",
  fieldMaxChars: "{{field}} debe tener como máximo {{max}} caracteres",
  fields: {
    firstName: "Nombre",
    lastName: "Apellidos",
    taxId: "Identificación fiscal",
    companyName: "Razón social",
    vatNumber: "NIF-IVA",
    companyTaxId: "Identificación fiscal de la empresa",
    birthDate: "Fecha de nacimiento",
    birthPlace: "Lugar de nacimiento",
    street: "Dirección",
    postalCode: "Código postal",
    city: "Ciudad",
    province: "Provincia",
    country: "País",
    documentType: "Tipo de documento",
    documentNumber: "Número de documento",
    documentIssuer: "Autoridad emisora",
    documentIssueDate: "Fecha de expedición del documento",
    documentExpiryDate: "Fecha de caducidad del documento",
    contactPhone: "Teléfono",
    contactEmail: "Correo electrónico",
    pec: "Correo certificado (PEC)",
    legalRepName: "Representante legal",
    accountHolder: "Titular de la cuenta",
  },
  invalidEmailFormat: "Formato de correo no válido",
  invalidPhoneFormat:
    "Número no válido. Usa formato internacional con prefijo + (p. ej. +393331234567).",
  invalidNotificationChannel:
    "Selecciona WhatsApp o correo para las notificaciones de reservas",
  invalidNotificationLanguage: "Selecciona un idioma para las notificaciones",
  ibanLength: "El IBAN debe tener entre 15 y 34 caracteres",
  documentExpiryBeforeIssue:
    "La fecha de caducidad debe ser igual o posterior a la de expedición",
} as const;
